export default {
    // WHITE LABEL
    DEV: {
        WHITE_LABEL_URL: 'https://ta-docs.ultimatejetvacations.test:8445',
        WHITE_LABEL_LUXURIA_URL: 'https://luxuria-docs.ultimatejetvacations.test:8445',
        UJV_WEBSITE: 'https://local-dev.ultimatejetvacations.test:8445',
    },
    PROD: {
        WHITE_LABEL_URL: 'https://www.travelagentjunkie.com',
        WHITE_LABEL_LUXURIA_URL: 'https://docs.luxuriavacations.com',
        UJV_WEBSITE: 'https://www.ultimatejetvacations.com',
    },
    // ADMIN
    ADMIN_URI: '/app/admin',

    // DASHBOARD
    DASHBOARD_URI: '/app/dashboard',
    RESERVATION_STATS: '/app/dashboard/reservation-stats',
    CANCELLATION_STATS: '/app/dashboard/cancellation-stats',
    USEFUL_INFO: '/app/dashboard/useful-info',

    WEBSITE: {
        BASE: '/website',
        ABOUT_US: 'about-us',
        CONTACT_US: 'contact-us',
        CFAR_PAGE: 'cfar-insurange',
        REWARDS: 'rewards',
        MARKETING: 'marketing',
        WEBINAR: 'webinar',
        HELPCENTER: 'helpcenter',
        FLIGHTS: 'flights',
        CONCIERGE: 'concierge',
        POLICY: 'Privacy-policy',
        FAQ: 'faq',
        DESTINATIONS: 'destinations',
        DESTINATION: 'destinations/:slug',
        HOME: '/',
        HOTELS: 'hotels',
        HOTEL: 'hotels/:slug',
        REGIONS: 'regions',
        REGION: 'region/:slug',
    },

    // WEB DOCUMENTS
    QUOTE_URI: '/app/documents/quote/:secureId',
    INVOICE_URI: '/app/documents/invoice/:secureId',
    ITINERARY_URI: '/app/documents/itinerary/:secureId',

    // MISC
    CHECKOUT_URI: '/app/checkout/:reservationId',
    NOT_FOUND: '/app/404',
};
